<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="3">
        <h3>Filter & Sort</h3>
        <tuto-info>

          <h4 class="pa-2">Sets</h4>
          <v-alert color="info" class="white--text pa-2">
            <strong class="">Sets</strong> are a list of tunes with settings (volume, speed, etc...) applied to recordings.
          </v-alert>
          <p class="pa-2">
            This <strong class="primary--text">Sets</strong> page lists all of your own sets as well as public sets from other users.
          </p>
          <p class="pa-2">
            You can <strong>Filter</strong> & <strong>Sort</strong> the available sets.
          </p>
          <p class="pa-2">
            You can also <strong>Create a new set</strong> by clicking the <v-btn color="primary" class="rounded-pill" x-small><v-icon>mdi-plus</v-icon>Create</v-btn> next to <strong class="primary--text">Sets</strong>.
          </p>
          <p class="pa-2">
            You can come back here by clicking <strong class="primary--text">Sets</strong> in
            <span class="overline primary--text">HOME > <span class="">SETS</span></span>.
          </p>
        </tuto-info>
      </v-col>
      <v-col cols="12" md="6">
        <div class="overline ">
          <router-link class="primary--text" to="/home">home</router-link> >
          sets
        </div>
        <div class="d-flex align-center">
          <h1 class="title-logo primary--text">Sets</h1>
          <v-btn
            color="primary"
            small
            class="ml-2 rounded-pill"
            @click="showCreateOverlay = !showCreateOverlay"
          >
            <v-icon>
              mdi-plus
            </v-icon>
            Create
          </v-btn>
        </div>
        <v-card class="" v-for="(set, i) in sets" :key="i" :to="'/sets/' + set.id"> 
          <v-card-title class="primary--text">
            {{ set.title }} 
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <span>created by <strong>{{ set.username }}</strong> {{ moment(set.created_at).fromNow() }}</span>
                <v-chip
                  small
                  class="ma-2"
                  color="grey"
                  text-color="white"
                  v-if="set.settings"
                >
                  <v-icon>
                    mdi-music-note
                  </v-icon>
                  {{ set.settings.length }} tunes
                </v-chip>
              </v-col>
              <v-col cols="6" v-if="set.private" class="d-flex align-center">
                <v-icon>mdi-lock</v-icon>
                <strong>This is a private set visible only to you.</strong>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-overlay :value="showCreateOverlay">
          <v-card light min-width="320px">
            <v-card-title>
              <h2 class="primary--text">Create a new set</h2>
            </v-card-title>
            <v-card-text>
              <v-form @submit.prevent="createSet">
                <v-text-field
                  v-model="newSet.title"
                  label="Set name"
                ></v-text-field>
                <v-switch
                  v-model="newSet.private"
                  label="Make set private"
                ></v-switch>
                <v-btn type="submit" block color="primary">Create</v-btn>
                <v-btn block @click="showCreateOverlay=false">Cancel</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-overlay>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import TradPlayer from '@/components/TradPlayer'

  import TutoInfo from '@/layout/TutoInfo.vue';
import moment from 'moment';
  export default {
  name: 'SetList',
  data: function () {
    return {
      showCreateOverlay: false,
      playIndex: 0,
      moment: moment,
      newSet: {
        title: '',
        private: false,
      }
    }  
  },
  computed: {
    sets: {
      get() {
        return this.$store.state.tune.sets;
      }
    }
  },
  components: {
    // TradPlayer,
    TutoInfo
  },
  mounted() {
    this.$store.dispatch('tune/getSetList');
  },
  methods: {
    createSet() {
      var vm = this;
      this.$store.dispatch('tune/createSet', this.newSet).then(function () {
        vm.showCreateOverlay = false;
      });
    },
    togglePlay() {
      this.$refs["player"][this.playIndex].togglePlay();
    },
    playNext() {
      this.playIndex++;
      if (this.playIndex < this.set.tunes.length) {
        this.startPlay();
      }
      else
        this.playIndex = 0;
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card { 
  transition: transform 0.2s ease-in-out;
}
.v-card:hover {
  transform: scale(1.1);
    .v-image__image--cover { 
      // transform: scale(1.1);
    }
}
</style>